@if (loaded) {
  <div class="modal-content">
    <div class="modal-header bg-tertiary">
      <h6 class="modal-title fw-bold" id="addConfigurationModalLabel">{{ isCreate() ? 'Add' : 'Edit' }} Configuration</h6>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="form" id="form" (ngSubmit)="onSubmit()">
        <div class="row mb-3">
          <div class="col-md-12 mb-3">
            <label for="ruleTitle" class="form-label fw-bold small small">Rule Title</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-clipboard"></i></span>
              <input type="text" class="form-control" id="ruleTitle" placeholder="Enter rule title"
                formControlName="name">
            </div>
          </div>
          <div class="col-md-12">
            <label for="subid" class="form-label fw-bold small small">SubID</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-filter"></i></span>
              <input type="text" class="form-control" id="subid" placeholder="Value" formControlName="subid">
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer bg-tertiary">
      <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>
      @if (isCreate()) {
        <button form="form" type="submit" class="btn btn-primary fw-bold">Create</button>
      }
      @if (!isCreate()) {
        <button form="form" type="submit" class="btn btn-primary fw-bold">Update</button>
      }
    </div>
  </div>
}
